import React, {useEffect, useState} from 'react';
import {t} from "i18next";
import {Modal} from "../components/Modal";
import {ChevronDownIcon} from "@radix-ui/react-icons";
import {Transition} from "@headlessui/react";
import {countryCodes} from "../data/CountryCode";
import {deleteSocialMedia, updateSocialMedia} from "../service/accountApi";
import Cookies from "universal-cookie";

export const EditSocialMediaForm = (props) => {
    const {
        showEditSocialMediaForm,
        setShowEditSocialMediaForm,
        socialMediaData,
        setSocialMediaData,
        accountDetails,
        setAccountDetails
    } = props;

    const cookies = new Cookies();
    const locale = cookies.get("locale");

    const socialMediaNames = [
        {
            label: t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.DEFAULT"),
            value: "",
        },
        {
            label: t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.WHATSAPP"),
            value: "whatsapp-number",
            icon: "/assets/whatsapp-icon.svg"
        },
        {
            label: t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.INSTAGRAM"),
            value: "instagram",
            icon: "/assets/instagram-icon.svg"
        },
        {
            label: t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.FACEBOOK"),
            value: "facebook",
            icon: "/assets/facebook-icon.svg"
        },
        {
            label: t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.TWITTER"),
            value: "twitter",
            icon: "/assets/twitter-x-icon.svg"
        },
        {
            label: t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.LINKEDIN"),
            value: "linkedin",
            icon: "/assets/linkedin-icon.svg"
        },
        {
            label: t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.PINTEREST"),
            value: "pinterest",
            icon: "/assets/pinterest-icon.svg"
        },
        {
            label: t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.YOUTUBE"),
            value: "youtube",
            icon: "/assets/youtube-icon.svg"
        }
    ]

    const [socialMediaDetails, setSocialMediaDetails] = useState({
        _id: '',

        socialMediaName: '',
        socialMediaLink: '',
    });

    const [selectedCountryCode, setSelectedCountryCode] = useState({
        charCode: 'IN',
        dialingCode: '+91',
        countryName: 'India'
    });

    const [isSocialMediaNameDropdownOpen, setIsSocialMediaNameDropdownOpen] = useState(false);
    const [isSelectingSocialMediaName, setIsSelectingSocialMediaName] = useState(false);

    const [isCountryCodeDropdownOpen, setIsCountryCodeDropdownOpen] = useState(false);
    const [isSelectingCountryCode, setIsSelectingCountryCode] = useState(false);

    const [error, setError] = useState({});

    const [isUpdateSocialMediaDetailsButtonDisabled, setIsUpdateSocialMediaDetailsButtonDisabled] = useState(false);
    const [isDeleteSocialMediaDetailsButtonDisabled, setIsDeleteSocialMediaDetailsButtonDisabled] = useState(false);

    const [showDeleteSocialMediaConfirmationModal, setShowDeleteSocialMediaConfirmationModal] = useState(false);

    const socialMediaNameLabel = (socialMediaName) => {
        switch (socialMediaName) {
            case 'whatsapp-number':
                return {
                    label: t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.WHATSAPP"),
                    icon: "/assets/whatsapp-icon.svg"
                };
            case 'instagram':
                return {
                    label: t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.INSTAGRAM"),
                    icon: "/assets/instagram-icon.svg"
                };
            case 'facebook':
                return {
                    label: t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.FACEBOOK"),
                    icon: "/assets/facebook-icon.svg"
                };
            case 'twitter':
                return {
                    label: t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.TWITTER"),
                    icon: "/assets/twitter-x-icon.svg"
                };
            case 'linkedin':
                return {
                    label: t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.LINKEDIN"),
                    icon: "/assets/linkedin-icon.svg"
                };
            case 'pinterest':
                return {
                    label: t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.PINTEREST"),
                    icon: "/assets/pinterest-icon.svg"
                };
            case 'youtube':
                return {
                    label: t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.YOUTUBE"),
                    icon: "/assets/youtube-icon.svg"
                };
            default:
                return {
                    label: t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.DEFAULT")
                };
        }
    }

    const validateSocialMediaLink = (platform, link) => {
        const platformRegex = {
            facebook: /^(?:https?:\/\/)?(?:www\.)?facebook\.com\/(?:[a-zA-Z0-9][a-zA-Z0-9\.]*[a-zA-Z0-9]{3,})?|(?:profile\.php\?id=[0-9]+)$/,
            twitter: /^(?:https?:\/\/)?(?:www\.)?(?:twitter\.com|x\.com)\/([a-zA-Z0-9_]{3,})+?\/?$/,
            linkedin: /^(?:https?:\/\/)?(?:www\.)?linkedin\.com\/(in|company)\/([a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9]{3,})+?\/?$/,
            pinterest: /^(?:https?:\/\/)?(?:[a-z]{1,3}\.)?pinterest\.com\/([a-zA-Z0-9][a-zA-Z0-9_]*)+?\/?$/,
            youtube: /^(?:(?:https)?:\/\/)?(?:www\.)?(?:youtube\.com|youtu.be)\/@([a-zA-Z0-9][a-zA-Z0-9\-_\.]*[a-zA-Z0-9])+?\/?$/,
            instagram: /^(?:(?:https)?:\/\/)?(?:www\.)?(?:instagram\.com|instagr.am)\/([a-zA-Z0-9_][a-zA-Z0-9_\.]*[a-zA-Z0-9_])+?\/?$/
        };

        const regex = platformRegex[platform];

        return regex.test(link);
    }

    const handleCountryCodeSelect = (countryCodeDetails) => {
        console.log("Country Code Details: ", countryCodeDetails);
        setIsSelectingCountryCode(false);
        setIsCountryCodeDropdownOpen(false);
        setSelectedCountryCode({
            charCode: countryCodeDetails.countryCode,
            dialingCode: countryCodeDetails.dialingCode,
            countryName: countryCodeDetails.countryName
        });
    }

    const isNumberValid = (phone) => {
        let reg = /^\d+$/;
        return reg.test(phone);
    }

    const validatePhoneNumber = (e) => {
        if ((!isNumberValid(e.target.value)) || e.target.value.length !== 10) {
            setError({
                ...error,
                [e.target.name]: t("PROFILE_FORM.PHONE_NUMBER.INVALID")
            });
        } else {
            setError({});
        }
    }

    const handleInvalidSocialMediaLinkError = () => {
        switch (socialMediaDetails.socialMediaName) {
            case 'facebook':
                return t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_LINK.INVALID_FACEBOOK_LINK_ERROR");
            case 'twitter':
                return t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_LINK.INVALID_TWITTER_LINK_ERROR");
            case 'linkedin':
                return t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_LINK.INVALID_LINKEDIN_LINK_ERROR");
            case 'pinterest':
                return t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_LINK.INVALID_PINTEREST_LINK_ERROR");
            case 'youtube':
                return t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_LINK.INVALID_YOUTUBE_LINK_ERROR");
            case 'instagram':
                return t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_LINK.INVALID_INSTAGRAM_LINK_ERROR");
        }
    }

    const handleFormData = (e) => {
        console.log(e.target.name + ': ' + e.target.value);

        setSocialMediaDetails({
            ...socialMediaDetails,
            [e.target.name]: e.target.value
        });

        setError({});
    }

    const validate = () => {
        let err = {};

        console.log("Social Media Details: ", socialMediaDetails);

        if (socialMediaDetails.socialMediaLink === '') {
            err['socialMediaLink'] = t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_LINK.REQUIRED_ERROR");
        } else {
            if (socialMediaDetails.socialMediaName !== "whatsapp-number" && !validateSocialMediaLink(socialMediaDetails.socialMediaName, socialMediaDetails.socialMediaLink)) {
                err['socialMediaLink'] = handleInvalidSocialMediaLinkError()
            }
        }

        return err;
    }

    const handleDelete = async () => {
        console.log("Inside Handle Delete!");
        setIsDeleteSocialMediaDetailsButtonDisabled(true);

        const socialMediaDataToDelete = {
            userAccountId: accountDetails._id,
            socialMediaId: socialMediaDetails._id,
        };
        const deleteAwardDataResponse = await deleteSocialMedia(socialMediaDataToDelete);

        console.log('(EditAwardForm) Delete Award Data Response: ', deleteAwardDataResponse);

        if (deleteAwardDataResponse.success) {
            setAccountDetails(deleteAwardDataResponse.data);
            setShowDeleteSocialMediaConfirmationModal(false);
            setShowEditSocialMediaForm(false);
            setIsDeleteSocialMediaDetailsButtonDisabled(false);
            setIsUpdateSocialMediaDetailsButtonDisabled(false);
            setTimeout(() => {
                if (socialMediaDetails.socialMediaName === "whatsapp-number") {
                    setSelectedCountryCode({
                        charCode: 'IN',
                        dialingCode: '+91',
                        countryName: 'India'
                    });
                }

                setSocialMediaDetails({
                    _id: '',

                    socialMediaName: '',
                    socialMediaLink: '',
                });

                setSocialMediaData(null);
            }, 200);
        }

    }

    const handleSubmit = async () => {
        console.log("Inside Handle Submit!");
        setIsUpdateSocialMediaDetailsButtonDisabled(true);
        const err = validate();

        if (Object.keys(err).length > 0 || Object.keys(error).length > 0) {
            console.log("Err: ", err);
            console.log("Error: ", error);

            setError((prevError) => {
                return {
                    ...prevError,
                    ...err
                }
            });
            setIsUpdateSocialMediaDetailsButtonDisabled(false);
            return;
        }

        console.log("Social Media Details: ", socialMediaDetails);

        const updatedSocialMediaData = {
            userAccountId: accountDetails._id,
            socialMediaDetails: {
                _id: socialMediaDetails._id,
                socialMediaName: socialMediaDetails.socialMediaName,
                socialMediaLink: socialMediaDetails.socialMediaName === "whatsapp"
                    ? "https://wa.me/" + selectedCountryCode.dialingCode.replace("+", "") + socialMediaDetails.socialMediaLink
                    : socialMediaDetails.socialMediaLink,
            },
        };

        const addSocialMediaDataResponse = await updateSocialMedia(updatedSocialMediaData);

        console.log('(AddSocialMediaForm) Add Social Media Data Response: ', addSocialMediaDataResponse);

        if (addSocialMediaDataResponse.success) {
            setAccountDetails(addSocialMediaDataResponse.data);
            setShowEditSocialMediaForm(false);
            setIsUpdateSocialMediaDetailsButtonDisabled(false);
            setTimeout(() => {
                if (socialMediaDetails.socialMediaName === "whatsapp-number") {
                    setSelectedCountryCode({
                        charCode: 'IN',
                        dialingCode: '+91',
                        countryName: 'India'
                    });
                }
                setSocialMediaDetails({
                    socialMediaName: '',
                    socialMediaLink: '',
                });
            }, 200);
        }
    }

    const handleClose = () => {
        setShowEditSocialMediaForm(false);
        setIsUpdateSocialMediaDetailsButtonDisabled(false);
        setTimeout(() => {
            setError({});
            setSocialMediaDetails({
                socialMediaName: '',
                socialMediaLink: '',
            });
            setSelectedCountryCode({
                charCode: 'IN',
                dialingCode: '+91',
                countryName: 'India'
            })
            setSocialMediaData(null);
        }, 200);
    }

    const deleteSocialMediaDetailsModalDescription = (socialMediaName) => {
        switch (socialMediaName) {
            case 'whatsapp-number':
                return {
                    p1: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.WHATSAPP_DESCRIPTION.P1", {
                        pronoun: window.location.pathname.includes("personal-profile")
                            ? locale === "mr" ? "तुमचे" : "your"
                            : locale === "mr" ? "त्यांचे" : "their"
                    }),
                    p2: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.WHATSAPP_DESCRIPTION.P2"),
                    p3: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.WHATSAPP_DESCRIPTION.P3")
                };
            case 'instagram':
                return {
                    p1: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.INSTAGRAM_DESCRIPTION.P1", {
                        pronoun: window.location.pathname.includes("personal-profile")
                            ? locale === "mr" ? "तुमचे" : "your"
                            : locale === "mr" ? "त्यांचे" : "their"
                    }),
                    p2: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.INSTAGRAM_DESCRIPTION.P2"),
                    p3: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.INSTAGRAM_DESCRIPTION.P3")
                };
            case 'facebook':
                return {
                    p1: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.FACEBOOK_DESCRIPTION.P1", {
                        pronoun: window.location.pathname.includes("personal-profile")
                            ? locale === "mr" ? "तुमचे" : "your"
                            : locale === "mr" ? "त्यांचे" : "their"
                    }),
                    p2: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.FACEBOOK_DESCRIPTION.P2"),
                    p3: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.FACEBOOK_DESCRIPTION.P3")
                };
            case 'twitter':
                return {
                    p1: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.TWITTER_DESCRIPTION.P1", {
                        pronoun: window.location.pathname.includes("personal-profile")
                            ? locale === "mr" ? "तुमचे" : "your"
                            : locale === "mr" ? "त्यांचे" : "their"
                    }),
                    p2: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.TWITTER_DESCRIPTION.P2"),
                    p3: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.TWITTER_DESCRIPTION.P3")
                };
            case 'linkedin':
                return {
                    p1: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.LINKEDIN_DESCRIPTION.P1", {
                        pronoun: window.location.pathname.includes("personal-profile")
                            ? locale === "mr" ? "तुमचे" : "your"
                            : locale === "mr" ? "त्यांचे" : "their"
                    }),
                    p2: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.LINKEDIN_DESCRIPTION.P2"),
                    p3: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.LINKEDIN_DESCRIPTION.P3")
                };
            case 'pinterest':
                return {
                    p1: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.PINTEREST_DESCRIPTION.P1", {
                        pronoun: window.location.pathname.includes("personal-profile")
                            ? locale === "mr" ? "तुमचे" : "your"
                            : locale === "mr" ? "त्यांचे" : "their"
                    }),
                    p2: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.PINTEREST_DESCRIPTION.P2"),
                    p3: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.PINTEREST_DESCRIPTION.P3")
                };
            case 'youtube':
                return {
                    p1: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.YOUTUBE_DESCRIPTION.P1", {
                        pronoun: window.location.pathname.includes("personal-profile")
                            ? locale === "mr" ? "तुमचे" : "your"
                            : locale === "mr" ? "त्यांचे" : "their"
                    }),
                    p2: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.YOUTUBE_DESCRIPTION.P2"),
                    p3: t("SOCIAL_MEDIA_FORM.DELETE_MODAL.YOUTUBE_DESCRIPTION.P3")
                };
        }
    }

    useEffect(() => {
        if (socialMediaData) {
            console.log("Social Media Data in Edit Social Media Form: ", socialMediaData);
            if (socialMediaData.socialMediaName === "whatsapp-number") {
                const whatsappNumberCountryCodeDetails = countryCodes.find(
                    country => country.countryDialingCode === "+" + socialMediaData.socialMediaLink
                        .replace("https://wa.me/", "")
                        .replace("/", "")
                        .slice(0, -10));

                console.log("WhatsApp Number Country Code Details: ", whatsappNumberCountryCodeDetails);
                setSelectedCountryCode({
                    charCode: whatsappNumberCountryCodeDetails.countryCode,
                    dialingCode: whatsappNumberCountryCodeDetails.countryDialingCode,
                    countryName: whatsappNumberCountryCodeDetails.countryName
                })
            }

            setSocialMediaDetails({
                _id: socialMediaData._id,
                socialMediaName: socialMediaData.socialMediaName,
                socialMediaLink: socialMediaData.socialMediaName === "whatsapp-number"
                    ? socialMediaData.socialMediaLink
                        .replace("https://wa.me/", "")
                        .replace("/", "")
                        .slice(-10)
                    : socialMediaData.socialMediaLink
            });
        }
    }, [socialMediaData]);

    useEffect(() => {
        if (showEditSocialMediaForm) {
            if (accountDetails.deceased) {
                socialMediaNames.filter(socialMedia => socialMedia.value !== 'whatsapp-number');
            }
        }
    }, [showEditSocialMediaForm]);

    return (
        <>
            {/* Edit Social Media Form */}
            <Modal isOpen={showEditSocialMediaForm}>
                <div className="fixed form-modal-container">
                    {/* Header */}
                    <div className={"form-modal-header-container"}>
                        {/* Header Title | Close Button */}
                        <div className={"flex flex-row items-center justify-between"}>
                            {/* Form Title */}
                            <h2>
                                {t("SOCIAL_MEDIA_FORM.EDIT_TITLE")}
                            </h2>

                            <button onClick={handleClose}>
                                <img
                                    className={"w-[75%] h-[75%]"}
                                    src={"/assets/close-icon.png"}
                                    alt={"Close"}
                                    title={"Close"}
                                />
                            </button>
                        </div>

                        {/* Divider */}
                        <div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
                    </div>

                    {/* Form Fields */}
                    <div className={"form-modal-body-container"}>
                        {/* Social Media Name */}
                        <fieldset>
                            <div className={`custom-input-container`}>
                                <label className="flex flex-row gap-1 text-gray-600 text-[1vw] font-custom-medium">
                                    {t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.LABEL")}
                                </label>
                                <div className="h-full w-full flex flex-col">
                                    <button
                                        disabled={true}
                                        className="custom-input-dropdown-button"
                                    >
                                        <div className={"flex-1 flex flex-row items-center gap-2"}>
                                            {
                                                socialMediaDetails.socialMediaName !== "" && (
                                                    <img
                                                        src={socialMediaNameLabel(socialMediaDetails.socialMediaName).icon}
                                                        alt={socialMediaNameLabel(socialMediaDetails.socialMediaName).label}
                                                    />
                                                )
                                            }
                                            <p>
                                                {socialMediaNameLabel(socialMediaDetails.socialMediaName).label}
                                            </p>
                                        </div>
                                    </button>

                                    {
                                        error['socialMediaName'] &&
                                        <p className="custom-input-error-message" id="error">
                                            {error['socialMediaName']}
                                        </p>
                                    }
                                </div>
                            </div>
                        </fieldset>

                        {/* Social Media Link | WhatsApp Number */}
                        {
                            socialMediaDetails.socialMediaName === "whatsapp-number"
                                ? (
                                    // Mobile Number Input
                                    <div className={"custom-phone-number-input"}>
                                        <label>
                                            {t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_NAME.LABEL_WP")}
                                        </label>
                                        <div className="h-full w-full flex flex-col">
                                            <div className="custom-phone-number-input-container">
                                                <button
                                                    onBlur={() => {
                                                        if (!isSelectingCountryCode) {
                                                            setIsCountryCodeDropdownOpen(false);
                                                        }
                                                    }}
                                                    onClick={() => setIsCountryCodeDropdownOpen(!isCountryCodeDropdownOpen)}
                                                >
                                                    <img
                                                        src={`/assets/country_flags/${selectedCountryCode.charCode}.png`}
                                                        alt={selectedCountryCode.countryName}
                                                    />
                                                    <p aria-selected={"false"}>
                                                        {selectedCountryCode.dialingCode}
                                                    </p>
                                                    <ChevronDownIcon
                                                        // onClick={() => setIsCountryCodeDropdownOpen(!isCountryCodeDropdownOpen)}
                                                        className={`${isCountryCodeDropdownOpen ? 'rotate-180' : 'rotate-0'} `}
                                                        aria-hidden="true"
                                                        stroke="#292D32"
                                                        strokeWidth={"0.1vh"}
                                                    />
                                                </button>
                                                <input
                                                    type="phone"
                                                    name="socialMediaLink"
                                                    placeholder="7734567890"
                                                    value={socialMediaDetails.socialMediaLink || ""}
                                                    onChange={handleFormData}
                                                    onBlur={validatePhoneNumber}
                                                    required
                                                />
                                            </div>

                                            {/* Country Code Dropdown */}
                                            <div className={""}>
                                                <Transition show={isCountryCodeDropdownOpen}>
                                                    <div
                                                        className={`bg-white absolute left-0 right-0 z-[100] max-h-[15vh]
                                                        origin-top-right rounded-md shadow-2xl mt-[0.5vh]
                                                        portrait:mx-[1.25rem] portrait:jk:mx-[1.75rem] portrait:lg:mx-[2.25rem]
                                                        landscape:mx-[0.75rem] landscape:jk:mx-[0.9rem] landscape:lg:mx-[1.15rem]
                                                        border border-gray-700 overflow-y-scroll
                                                        data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 
                                                        data-[enter]:duration-100 data-[enter]:ease-out 
                                                        data-[leave]:duration-75 data-[leave]:ease-in`}
                                                    >
                                                        {
                                                            countryCodes.map((country, index) => (
                                                                <button
                                                                    key={index}
                                                                    className="custom-phone-number-input-dropdown-button hover:bg-gray-300"
                                                                    onMouseDown={() => setIsSelectingCountryCode(true)}
                                                                    onClick={() => handleCountryCodeSelect(country)}
                                                                >
                                                                    <img
                                                                        src={country.countryFlagSrc}
                                                                        alt={country.countryName}
                                                                    />
                                                                    <p
                                                                        className={"text-left"}
                                                                        aria-selected={"false"}
                                                                    >
                                                                        {country.countryName}
                                                                    </p>
                                                                    <p aria-selected={"false"}>
                                                                        {'(' + country.countryDialingCode + ')'}
                                                                    </p>
                                                                </button>
                                                            ))
                                                        }
                                                    </div>
                                                </Transition>
                                            </div>
                                        </div>

                                        {
                                            error['socialMediaLink'] &&
                                            <p className="custom-input-error-message" id="error">
                                                {error['socialMediaLink']}
                                            </p>
                                        }
                                    </div>
                                )
                                : (
                                    // Social Media Link
                                    <div className="custom-input-container">
                                        <label htmlFor="socialMediaLink">
                                            {t("SOCIAL_MEDIA_FORM.SOCIAL_MEDIA_LINK.LABEL")}
                                        </label>

                                        <div className="flex-1 flex flex-col">
                                            <input
                                                id="socialMediaLink"
                                                className="custom-input"
                                                name='socialMediaLink'
                                                value={socialMediaDetails.socialMediaLink}
                                                onChange={handleFormData}
                                                disabled={socialMediaDetails.socialMediaName === ""}
                                            />
                                            {
                                                error['socialMediaLink'] &&
                                                <p className="custom-input-error-message" id="error">
                                                    {error['socialMediaLink']}
                                                </p>
                                            }
                                        </div>
                                    </div>
                                )
                        }
                    </div>

                    {/* Footer */}
                    <div className={"form-modal-footer-container"}>
                        {/* Divider */}
                        <div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full mb-[1.5vh]"}/>

                        {/* Delete Button | Submit Button Container */}
                        <div className="flex items-center justify-between">
                            {/* Delete Button */}
                            <button
                                disabled={isDeleteSocialMediaDetailsButtonDisabled || isUpdateSocialMediaDetailsButtonDisabled}
                                onClick={() => setShowDeleteSocialMediaConfirmationModal(true)}
                                className="form-modal-footer-container-delete-button"
                            >
                                <img
                                    src="/assets/delete-icon-filled-light.png"
                                    alt="Delete"
                                />
                                <p>
                                    {t("SOCIAL_MEDIA_FORM.DELETE")}
                                </p>
                            </button>

                            {/* Submit Button */}
                            <button
                                disabled={isUpdateSocialMediaDetailsButtonDisabled || isDeleteSocialMediaDetailsButtonDisabled}
                                onClick={handleSubmit}
                                className="form-modal-footer-container-submit-button"
                            >
                                <p>
                                    {t("SOCIAL_MEDIA_FORM.EDIT_SUBMIT")}
                                </p>
                                <svg
                                    viewBox="0 0 6 6"
                                    fill="none"
                                    id={"arrow-icon"}
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M3 1L5 3L3 5"
                                        id={"arrow-icon-tip"}
                                        stroke="black"
                                        strokeLinecap="square"
                                    />
                                    <path
                                        d="M1 3L4 3"
                                        id={"arrow-icon-line"}
                                        stroke="black"
                                        strokeLinecap="square"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Delete Award */}
            <Modal isOpen={showDeleteSocialMediaConfirmationModal}>
                <div className="delete-modal-container">
                    {/* Header */}
                    <div className={"delete-modal-header-container"}>
                        {/* Header Title | Close Button */}
                        <div className={"flex flex-row items-center justify-between"}>
                            {/* Form Title */}
                            <h2>
                                {t("SOCIAL_MEDIA_FORM.DELETE_MODAL.TITLE")}
                            </h2>

                            <button
                                onClick={() => setShowDeleteSocialMediaConfirmationModal(false)}
                            >
                                <img
                                    className={"w-[75%] h-[75%]"}
                                    src={"/assets/close-icon.png"}
                                    alt={"Close"}
                                    title={"Close"}
                                />
                            </button>
                        </div>

                        {/* Divider */}
                        <div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
                    </div>

                    {/* Content */}
                    {
                        socialMediaDetails.socialMediaName !== "" && (
                            <div className={"delete-modal-body-container"}>
                                <p>
                                    {deleteSocialMediaDetailsModalDescription(socialMediaDetails.socialMediaName).p1}
                                    <span className={"!font-custom-semi-bold underline"}>
                                        {deleteSocialMediaDetailsModalDescription(socialMediaDetails.socialMediaName).p2}
                                    </span>
                                    {deleteSocialMediaDetailsModalDescription(socialMediaDetails.socialMediaName).p3}
                                </p>
                            </div>
                        )
                    }

                    {/* Footer */}
                    <div className={"delete-modal-footer-container"}>
                        {/* Divider */}
                        <div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>

                        {/* Cancel Button | Delete Button Container */}
                        <div className="flex flex-row items-center justify-between">
                            {/* Cancel Button */}
                            <button
                                disabled={isDeleteSocialMediaDetailsButtonDisabled}
                                onClick={() => setShowDeleteSocialMediaConfirmationModal(false)}
                                className="delete-modal-footer-container-cancel-button"
                            >
                                <p>
                                    {t("SOCIAL_MEDIA_FORM.DELETE_MODAL.CANCEL")}
                                </p>
                                <svg
                                    viewBox="0 0 6 6"
                                    fill="none"
                                    id={"arrow-icon"}
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M3 1L5 3L3 5"
                                        id={"arrow-icon-tip"}
                                        stroke="black"
                                        strokeLinecap="square"
                                    />
                                    <path
                                        d="M1 3L4 3"
                                        id={"arrow-icon-line"}
                                        stroke="black"
                                        strokeLinecap="square"
                                    />
                                </svg>
                            </button>

                            {/* Delete Button */}
                            <button
                                disabled={isDeleteSocialMediaDetailsButtonDisabled}
                                onClick={handleDelete}
                                className="delete-modal-footer-container-delete-button"
                            >
                                <img
                                    src="/assets/delete-icon-filled-light.png"
                                    alt="Delete"
                                />
                                <p>
                                    {t("SOCIAL_MEDIA_FORM.DELETE_MODAL.DELETE")}
                                </p>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}
